import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import moment from "moment";
import Breadcrumb from "../../components/common/breadcrumb";
import PasswordForm from "../../components/common/profile/passwordForm";
import ProfileForm from "../../components/common/profile/profileForm";
import MfaForm from "../../components/common/profile/mfaForm";
import PersuasionModalProfle from "../../components/MfaModals/persuasionModalProfile";
import OutOfOffice from "../../components/common/profile/outOfOffice";
// import PersuasionModalLogin from "../../components/MfaModals/persuasionModalLogin";

const Profile = () => {
  const currentUser = JSON.parse(localStorage.getItem("authUser"));
  const originalUser = JSON.parse(localStorage.getItem("original-authUser"));
  const isRemplacing = !!(originalUser && originalUser.user);

  const [persuasionModal, setPersuasionModal] = useState(false);
  const [openConfigModals, setOpenConfigModals] = useState(false);
  const lastPersuasionDate = localStorage.getItem("persuasion");

  const hanPasado30Dias = (fecha) => {
    const fechaActual = moment();
    const fechaComparar = moment(fecha, "DD,MM,YYYY");
    const diferenciaDias = fechaActual.diff(fechaComparar, "days");

    return diferenciaDias >= 30;
  };
  const handleOpenConfigModals = () => {
    setOpenConfigModals(!openConfigModals);
  };

  // estas funciones validan las condiciones para mostrar el modal de persuasion
  useEffect(() => {
    if (lastPersuasionDate) {
      setPersuasionModal(hanPasado30Dias(lastPersuasionDate));
    } else if (currentUser.user.twofa !== 1) {
      setPersuasionModal(true);
    } else {
      setPersuasionModal(false);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>PIN - Perfil</title>
      </Helmet>
      <Breadcrumb title="Editar Perfil" parent="Perfil" />
      <div className="container-fluid">
        <div className="edit-profile">
          <div className="row">
            <div className="col-lg-12">
              <ProfileForm isRemplacing={isRemplacing} />
            </div>
            <div className="col-lg-12 mb-3">
              <h5 className="badge-pills" style={{ marginLeft: "15px" }}>
                SEGURIDAD
              </h5>
            </div>
            <div className="col-lg-12 d-flex justify-content-between">
              <div className="col-lg-6">
                <PasswordForm isRemplacing={isRemplacing} />
              </div>
              <div className="col-lg-6">
                <MfaForm openConfigModals={openConfigModals} isRemplacing={isRemplacing} />
                <OutOfOffice currentUser={currentUser} />
              </div>
              {/* <PersuasionModalLogin
                isOpen={persuasionModal}
                button={false}
                toggle={() => {
                  setPersuasionModal(!persuasionModal);
                }}
                openConfigModals={handleOpenConfigModals}
              /> */}
              <PersuasionModalProfle
                isOpen={persuasionModal}
                button={false}
                toggle={() => {
                  setPersuasionModal(!persuasionModal);
                }}
                openConfigModals={handleOpenConfigModals}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
